import { getPlatform } from './get-platform';
import { getQueryParam } from './get-query-param';

export function getCheckoutOriginHeaders() {
  return {
    'x-source-version': getQueryParam('source-version'),
    'x-sdk-version': getQueryParam('sdk-version'),
    'x-client-platform': getPlatform(),
    'x-resource': getQueryParam('resource'),
    'x-engine': getQueryParam('engine'),
  };
}
